var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 469.333,
    height: 469.333,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.667,0h-256C51.093,0,32,19.093,32,42.667v298.667h42.667V42.667h256V0z",
    id: "svg_4",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.667,85.333H160c-23.573,0-42.667,19.093-42.667,42.667v298.667c0,23.573,19.093,42.667,42.667,42.667h234.667     c23.573,0,42.667-19.093,42.667-42.667V128C437.333,104.427,418.24,85.333,394.667,85.333z M394.667,426.667H160V128h234.667     V426.667z",
    id: "svg_5",
    fill: "#ffffff",
    fillOpacity: 1
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bdb96cb95666bdeb471837e94a4da6c3.svg";
export { ForwardRef as ReactComponent };